<div class="d-flex flex-column">
  <div class="detail-label">{{ label }}</div>
  <div class="detail-value {{ submissionState }}" [class.changed]="hasChanged">
    <span [innerHTML]="displayedValue$ | async"></span>
    <button
      class="eye"
      type="button"
      (click)="toggleShowHide()"
      [disabled]="disabled"
      [ngClass]="{
        opened: !(showMaskedSin$ | async),
        closed: (showMaskedSin$ | async),
        disabled: disabled
      }"></button>
  </div>
</div>
